import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'community',
    lazy: async () => ({ Component: (await import('./CommunityPage')).CommunityPage }),
  },
];
